import React,{useState,useEffect,lazy,useRef} from 'react';
import axios from 'axios'
import {  Slider,Statistic,Tabs,Modal } from 'antd';
import { ArrowUpOutlined,MinusCircleFilled,ToolOutlined, ArrowDownOutlined,FileFilled,WalletFilled,SearchOutlined,FundViewOutlined,
   UserOutlined, AccountBookOutlined,CalculatorFilled,SwapOutlined,GroupOutlined,AccountBookFilled, DollarCircleOutlined,EditFilled,MessageFilled,DollarOutlined,CarFilled,LoadingOutlined,PlusCircleFilled,
   DownloadOutlined,PrinterOutlined,FileExcelOutlined,FilePdfOutlined } from '@ant-design/icons';
import moment from 'moment';
import {withGetScreen} from 'react-getscreen'
import { Popover,Table,Popconfirm,Input, Button,Collapse,Card,Avatar,Form,DatePicker,Select,Space,Typography,Divider,InputNumber,message,Spin } from 'antd';
import { Bar } from 'react-chartjs-2';
import * as XLSX from 'xlsx';
import { Table as ReactstrapTable } from 'reactstrap';

var CryptoJS = require("crypto-js");

const { TextArea } = Input;
const antIcon = <LoadingOutlined style={{ fontSize: 40 }} spin />;

const style = { background: '#0092ff', padding: '8px 0',borderRadius: '7px',justifyContent:'center', alignItems:'center',display: 'flex', };
const dateFormat = 'DD/MM/YYYY';
const yeardateFormat = 'YYYY';
const monthdateFormat = 'MM/YYYY';

const { Meta } = Card;
const { Panel } = Collapse;
const { TabPane } = Tabs;
const FormItem=Form.Item;
const { Option } = Select;

var bizuserid= ''
var sacco= ''
var token= ''


class TrackingTable extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      datarequested:true,
      tracking_hubs_report:[]
    };
  }

  componentDidMount(){
    this.setState({tracking_hubs_report:this.props.tracking_hubs_report})
    this.setState({datarequested:false})
  }

  // Prepare data for Excel export
  prepareExcelData = () => {
    return this.state.tracking_hubs_report.map((record, index) => {
      // Helper function to safely convert values to strings
      const safeString = (value) => {
        if (value === null || value === undefined) return 'N/A';
        if (typeof value === 'object') return JSON.stringify(value);
        return String(value);
      };

      // Helper function to safely get array length
      const safeArrayLength = (arr) => {
        if (!arr || !Array.isArray(arr)) return 0;
        return arr.length;
      };

      // Helper function to safely format percentage
      const safePercentage = (value) => {
        if (value === null || value === undefined || value === '') return '0%';
        const numValue = parseFloat(value);
        if (isNaN(numValue)) return '0%';
        return `${numValue}%`;
      };

      return {
        'S/N': index + 1,
        'Hub Name': safeString(record.name),
        'Facilities Served': safeArrayLength(record.facilities_served),
        'Facilities Visited': safeArrayLength(record.facilities_visited),
        'Visit Percentage': safePercentage(record.percentage_vist),
        'Districts Covered': safeString(record.districts_covered),
        'Health Region': safeString(record.region)
      };
    });
  }

  // Alternative Excel export using XLSX library directly
  exportToExcelAlternative = () => {
    try {
      const data = this.prepareExcelData();
      
      if (data.length === 0) {
        message.warning('No data available to export');
        return;
      }

      // Create a new workbook
      const wb = XLSX.utils.book_new();
      
      // Convert data to worksheet
      const ws = XLSX.utils.json_to_sheet(data);
      
      // Add worksheet to workbook
      XLSX.utils.book_append_sheet(wb, ws, 'Hub Tracking Report');
      
      // Generate filename
      const filename = `Hub_Tracking_Report_${moment().format('DD_MM_YYYY')}.xlsx`;
      
      // Save file
      XLSX.writeFile(wb, filename);
      
      message.success('Excel file downloaded successfully!');
    } catch (error) {
      console.error('Excel export error:', error);
      message.error('Failed to export Excel file. Please try again.');
    }
  }

  // Handle print functionality with better layout and reactstrap table
  handlePrint = () => {
    const data = this.state.tracking_hubs_report;
    
    // Create print-friendly table HTML using reactstrap structure
    const printTableRows = data.map((record, index) => `
      <tr>
        <td style="text-align: center;">${index + 1}</td>
        <td>${record.name || 'N/A'}</td>
        <td style="text-align: center;">${record.facilities_served ? record.facilities_served.length : 0}</td>
        <td style="text-align: center;">${record.facilities_visited ? record.facilities_visited.length : 0}</td>
        <td style="text-align: center;">${record.percentage_vist || 0}%</td>
        <td>${record.districts_covered || 'N/A'}</td>
        <td>${record.region || 'N/A'}</td>
      </tr>
    `).join('');

    const printContent = `
      <html>
        <head>
          <title>Hub Tracking Report - ${moment().format('DD/MM/YYYY')}</title>
          <style>
            @page {
              margin: 1in;
              size: landscape;
            }
            
            body { 
              font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif; 
              margin: 0;
              padding: 20px;
              background: white;
              color: #333;
              line-height: 1.4;
            }
            
            .print-container {
              max-width: 100%;
              margin: 0 auto;
              text-align: center;
            }
            
            .print-header { 
              text-align: center; 
              margin-bottom: 40px; 
              border-bottom: 3px solid #0092ff;
              padding-bottom: 20px;
            }
            
            .print-header h1 { 
              color: #0092ff; 
              margin-bottom: 10px;
              font-size: 28px;
              font-weight: bold;
              text-transform: uppercase;
              letter-spacing: 1px;
            }
            
            .print-header p { 
              margin: 8px 0; 
              color: #666; 
              font-size: 14px;
            }
            
            .report-info {
              display: flex;
              justify-content: space-between;
              align-items: center;
              margin: 20px 0;
              padding: 10px;
              background: #f8f9fa;
              border-radius: 5px;
            }
            
            .print-table-container {
              margin: 30px auto;
              overflow-x: auto;
            }
            
            table { 
              width: 100%; 
              border-collapse: collapse; 
              margin: 0 auto;
              background: white;
              box-shadow: 0 2px 4px rgba(0,0,0,0.1);
            }
            
            th { 
              background: linear-gradient(135deg, #0092ff 0%, #0066cc 100%);
              color: white;
              font-weight: bold;
              padding: 12px 8px;
              text-align: center;
              font-size: 12px;
              text-transform: uppercase;
              letter-spacing: 0.5px;
              border: 1px solid #0066cc;
            }
            
            td { 
              border: 1px solid #ddd; 
              padding: 10px 8px; 
              font-size: 11px;
              vertical-align: middle;
            }
            
            tr:nth-child(even) { 
              background-color: #f8f9fa; 
            }
            
            tr:hover {
              background-color: #e3f2fd;
            }
            
            .print-footer { 
              margin-top: 40px; 
              text-align: center; 
              font-size: 11px; 
              color: #666;
              border-top: 2px solid #0092ff;
              padding-top: 20px;
            }
            
            .stats-summary {
              display: flex;
              justify-content: space-around;
              margin: 20px 0;
              padding: 15px;
              background: #f1f8ff;
              border-radius: 8px;
              border-left: 4px solid #0092ff;
            }
            
            .stat-item {
              text-align: center;
            }
            
            .stat-number {
              font-size: 24px;
              font-weight: bold;
              color: #0092ff;
            }
            
            .stat-label {
              font-size: 12px;
              color: #666;
              text-transform: uppercase;
            }
            
            @media print {
              .print-container {
                max-width: none;
              }
              
              body {
                padding: 0;
                margin: 0;
              }
            }
          </style>
        </head>
        <body>
          <div class="print-container">
            <div class="print-header">
              <h1>Umoja Hub Tracking Report</h1>
              <div class="report-info">
                <span><strong>Generated:</strong> ${moment().format('DD/MM/YYYY HH:mm')}</span>
                <span><strong>Total Hubs:</strong> ${data.length}</span>
                <span><strong>Report Type:</strong> Performance Analysis</span>
              </div>
            </div>

            <div class="stats-summary">
              <div class="stat-item">
                <div class="stat-number">${data.length}</div>
                <div class="stat-label">Total Hubs</div>
              </div>
              <div class="stat-item">
                <div class="stat-number">${data.reduce((sum, hub) => sum + (hub.facilities_served ? hub.facilities_served.length : 0), 0)}</div>
                <div class="stat-label">Facilities Served</div>
              </div>
              <div class="stat-item">
                <div class="stat-number">${data.reduce((sum, hub) => sum + (hub.facilities_visited ? hub.facilities_visited.length : 0), 0)}</div>
                <div class="stat-label">Facilities Visited</div>
              </div>
              <div class="stat-item">
                <div class="stat-number">${data.length > 0 ? Math.round(data.reduce((sum, hub) => sum + (parseFloat(hub.percentage_vist) || 0), 0) / data.length) : 0}%</div>
                <div class="stat-label">Average Performance</div>
              </div>
            </div>
            
            <div class="print-table-container">
              <table>
                <thead>
                  <tr>
                    <th>S/N</th>
                    <th>Hub Name</th>
                    <th>Facilities Served</th>
                    <th>Facilities Visited</th>
                    <th>Percentage</th>
                    <th>Districts Covered</th>
                    <th>Health Region</th>
                  </tr>
                </thead>
                <tbody>
                  ${printTableRows}
                </tbody>
              </table>
            </div>
            
            <div class="print-footer">
              <p><strong>© ${moment().format('YYYY')} Umoja Integrated Couriers</strong></p>
              <p>Hub Performance Report - Confidential Document</p>
              <p>Generated by Umoja Public Tracker System</p>
            </div>
          </div>
        </body>
      </html>
    `;

    // Create a new window for printing
    const printWindow = window.open('', '_blank');
    printWindow.document.write(printContent);
    printWindow.document.close();
    
    // Wait for content to load then print
    printWindow.onload = function() {
      printWindow.print();
      printWindow.close();
    };
    
    message.success('Print dialog opened successfully!');
  }

render() {

    var my_columns = [
      {
        title: 'Name',
        dataIndex: 'name',
        key: 'id',
      },
      {
        title: 'Facilities Served',
        dataIndex: 'id',
        key: 'id',
        render: (text,record) =>
          <p>
            {record.facilities_served.length}
          </p>
      },
      {
        title: 'Facilities Visited',
        dataIndex: 'id',
        key: 'id',
        render: (text,record) =>
          <p>
            {record.facilities_visited.length}
          </p>
      },
      {
        title: 'Percentage',
        dataIndex: 'percentage_vist',
        key: 'id',
      },
      {
        title: 'Districts Covered by hub',
        dataIndex: 'districts_covered',
        key: 'id',
      },
      {
        title: 'Health region',
        dataIndex: 'region',
        key: 'id',
      }

    ];

    // Note: Excel export handled by alternative method using XLSX library

      if(this.state.datarequested===true){
        return(
          <div style={{display: 'flex',  justifyContent:'center', alignItems:'center' }}>
                <Spin size="large">
                <div className="content">
                  <h3>Umoja Couriers</h3>
                </div>
                </Spin>        
          </div>
        )
      }else{

      return (
                <div className="animated fadeIn"> 
                  
                  {/* Action Buttons */}
                  <div style={{ marginBottom: 16, display: 'flex', gap: 8, justifyContent: 'flex-end' }}>
                    
                                         {/* Excel Download Button */}
                     <Button 
                       type="primary" 
                       icon={<FileExcelOutlined />}
                       style={{ backgroundColor: '#52c41a', borderColor: '#52c41a' }}
                       onClick={this.exportToExcelAlternative}
                     >
                       Download Excel
                     </Button>

                    {/* Print/PDF Button */}
                    <Button 
                      type="primary" 
                      icon={<PrinterOutlined />}
                      onClick={this.handlePrint}
                      style={{ backgroundColor: '#fa541c', borderColor: '#fa541c' }}
                    >
                      Print/PDF
                    </Button>

                  </div>

                                     {/* Screen Display Table (No pagination in print) */}
                   <Table   
                     columns={my_columns} 
                     scroll={{ x: 1000 }}
                     dataSource={this.state.tracking_hubs_report} 
                     pagination={{showQuickJumper:true,showSizeChanger:true }}
                     bordered

                     expandable={{
                       expandedRowRender: (record) =>{
                       return (
                         <div style={{margin: 0,}}>
                           <Tabs defaultActiveKey="1" onChange={()=>{}}>
                             <TabPane tab="Visited " key="1">
                               {record.facilities_visited && record.facilities_visited.length > 0 ? (
                                 <ul>
                                   {record.facilities_visited.map((facility, index) => (
                                     <li key={index}>{facility.name || facility}</li>
                                   ))}
                                 </ul>
                               ) : (
                                 <p>No visited facilities data available</p>
                               )}
                             </TabPane>

                             <TabPane tab="Not Visited " key="2">
                               {record.facilities_served && record.facilities_visited ? (
                                 <ul>
                                   {record.facilities_served
                                     .filter(served => !record.facilities_visited.some(visited => 
                                       (visited.name || visited) === (served.name || served)
                                     ))
                                     .map((facility, index) => (
                                       <li key={index}>{facility.name || facility}</li>
                                     ))
                                   }
                                 </ul>
                               ) : (
                                 <p>No facilities data available</p>
                               )}
                             </TabPane>
                         </Tabs>
                         </div>
                         );
                        
                       } ,
                       rowExpandable: (record) => true,
                       onExpand:(condition,record)=>{
                       },
                     }}   
                     
                   />

        </div>
      );

    }

}
}

export default TrackingTable; 
